import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { LoaderComponent } from './components/loader/loader.component';
import { AuthInterceptor } from './interceptors/auth/auth.interceptor';
import { ErrorsInterceptor } from './interceptors/error/error.interceptor';
import { LoaderInterceptor } from './interceptors/loader/loader.interceptor';
import { TenantInterceptor } from './interceptors/tenant/tenant.interceptor';

const MODULES = [
  CommonModule,
  BrowserAnimationsModule
];

const COMPONENTS = [
  LoaderComponent
];

@NgModule({
  declarations: [
    ...COMPONENTS,
  ],
  imports: [
    ...MODULES,
    ToastrModule.forRoot({
      closeButton: true,
      timeOut: 3000,
      extendedTimeOut: 3000,
      //progressBar: true,
      //disableTimeOut: true,
      maxOpened: 1,
      autoDismiss: true,
      positionClass: 'toast-top-center',
      preventDuplicates: true,
    }),
  ],
  exports: [
    ...MODULES,
    ...COMPONENTS
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TenantInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorsInterceptor,
      multi: true
    }
  ]
})
export class CoreModule { }
